import { type ITooltipHostProps, TooltipHost as MSTooltipHost } from '@fluentui/react'
import { useMediaQuery } from 'react-responsive'

export const TooltipHost = (props: ITooltipHostProps) => {
  const hasHover = useMediaQuery({ query: '(hover: hover) and (pointer: fine)' })
  return <MSTooltipHost {...props} hidden={hasHover ? props.hidden : true} />
}
